import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ls from 'local-storage';
import { login } from '../services/Login';
import toast from 'react-hot-toast';

const LoginPage = () => {
    
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [processing, setProcessing] = useState('');

  useEffect(() => {
    if (ls.get('skBOToken') && ls.get('userDetail')) {
      navigate('/');
    }
  }, []);

  async function handleLogin (e) {
    e.preventDefault();
    setProcessing(true);
    const response = await login(email, password);
    
    if(!response.success){
      toast.error(response.message);
      setProcessing(false);
      return;
    }

    toast.success(response.message);

    ls.set('skBOToken', response.token);
    ls.set('userDetail', response.userDetail);

    setTimeout(() => {
        navigate('/');
    }, 500);

  };

  return (
    <>        
        <div className="min-h-screen flex items-center justify-center bg-[#2b478e] p-4">
          <div className="bg-white max-w-md w-full p-8 rounded-xl shadow-lg">
              <center>
              <img src="/latest-logo.jpg" alt="Logo" className="w-24 h-24 mb-4 rounded-full object-cover" />
              </center>
              <h1 className="text-2xl font-bold text-center mb-6 text-blue-800">
              Sukhakala Voucher Tracker
              </h1>

              <form onSubmit={handleLogin}>
              <div className="mb-4">
                  <label className="block text-sm font-medium mb-1 text-gray-700">Email</label>
                  <input
                  type="email"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="masukkan email kamu"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  />
              </div>

              <div className="mb-6">
                  <label className="block text-sm font-medium mb-1 text-gray-700">Password</label>
                  <input
                  type="password"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  />
              </div>

              <button
                  type="submit"
                  className="w-full bg-yellow-500 text-white font-semibold py-3 rounded-lg hover:bg-yellow-600 transition"
                  disabled={processing}
              >
                  {processing ? 'Processing...' : 'Login'}
              </button>
              </form>
          </div>
        </div>
    </>
  );
};

export default LoginPage;
